import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser'
import KeychainChain from '../game/KeychainChain';
import gameData from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import UIAssetKeys from '../UIAssetKeys';
import ColorSelectionButton from './ColorSelectionButton';
import MenuController from './MenuController';
import ABCyaLib from '@abcya/abcya_lib';

export default class SubMenu extends Phaser.GameObjects.Container
{
    /**
     * 
     * @param {Phaser.Scene} scene 
     * @param {Phaser.GameObjects.Container} dragContainer
     * @param {MenuController} delegate
     */
    constructor(scene, dragContainer, delegate)
    {
        super(scene);

        this.dragContainer = dragContainer;
        this.delegate = delegate;

        this.colorFillButtonGlow = ABCyaPhaser.Images.addImage(0, 0, UIAssetKeys._game_assets_COLOR_fill_glow, this);
        this.colorFillButtonGlow.visible = false;

        let SUBMENU_WIDTH = this.scene.scale.width;
        let SUBMENU_HEIGHT = 144;

        this.SIDE_MARGINS = 40;

        this.xpos = 0;

        this.vX = 0;
        this.minX = 0;
        this.maxX = 0;

        this.submenuContainer = this.scene.add.container();
        this.subBg = this.scene.add.rectangle(0, 0, this.scene.scale.width, SUBMENU_HEIGHT, 0x09a933).setOrigin(0);
        this.subBg.fillColor = 0xff0000;
        this.add(this.subBg);

        this.menuItems = [];
        this.menuItemsContainer = this.scene.add.container().setVisible(false);

        this.colorItems = [];
        this.colorSwatches = [];
        this.colorItemsContainer = this.scene.add.container().setVisible(false);

        this.submenuContainer.add(this.menuItemsContainer);
        this.add(this.colorItemsContainer);
        this.add(this.submenuContainer);

        let sidePadding = this.SIDE_MARGINS;
        this.submenuContainerMaskShape = this.scene.add.rectangle(sidePadding, 0, SUBMENU_WIDTH - sidePadding * 2, SUBMENU_HEIGHT, 0x000000).setOrigin(0).setVisible(false);
        this.submenuContainer.setMask(new Phaser.Display.Masks.GeometryMask(this.scene, this.submenuContainerMaskShape));
        this.scene.events.on(Phaser.Scenes.Events.POST_UPDATE, this.onPostUpdate, this);
        this.once(Phaser.GameObjects.Events.DESTROY, () => this.scene.events.off(Phaser.Scenes.Events.POST_UPDATE, this.onPostUpdate, this));

        this.btnLeftArrow = ABCyaPhaser.Images.addImage(0, SUBMENU_HEIGHT / 2, UIAssetKeys._game_assets_BUTTON_arrow_left, this);
        this.btnLeftArrow.setInteractive(
            {
                hitArea: new Phaser.Geom.Rectangle(0, -SUBMENU_HEIGHT / 2 + (this.btnLeftArrow.height / 2), this.btnLeftArrow.width, SUBMENU_HEIGHT),
                hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                useHandCursor: true
            }
        );
        this.btnLeftArrow.x = (this.btnLeftArrow.width / 2) + 2;
        this.btnRightArrow = ABCyaPhaser.Images.addImage(0, SUBMENU_HEIGHT / 2, UIAssetKeys._game_assets_BUTTON_arrow_right, this);
        this.btnRightArrow.setInteractive(
            {
                hitArea: new Phaser.Geom.Rectangle(0, -SUBMENU_HEIGHT / 2 + (this.btnRightArrow.height / 2), this.btnRightArrow.width, SUBMENU_HEIGHT),
                hitAreaCallback: Phaser.Geom.Rectangle.Contains,
                useHandCursor: true
            }
        );
        this.btnRightArrow.x = SUBMENU_WIDTH - (this.btnRightArrow.width / 2) - 2;

        this.btnLeftArrow.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onArrowClick(this.btnLeftArrow), this);
        this.btnLeftArrow.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onArrowRelease, this);
        this.btnRightArrow.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onArrowClick(this.btnRightArrow), this);
        this.btnRightArrow.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, this.onArrowRelease, this);

        this.add([this.btnLeftArrow, this.btnRightArrow, this.colorFillButtonGlow]);

        this.workingWidth = SUBMENU_WIDTH;
        this.workingHeight = SUBMENU_HEIGHT;
    }

    onPostUpdate(time, delta)
    {
        const screenPos = ABCyaPhaser.GameObjects.getScreenPosition(this.submenuContainer);
        this.submenuContainerMaskShape.setPosition(screenPos.x + this.SIDE_MARGINS, screenPos.y);

        let newX = this.xpos;
        newX += this.vX * (delta / 1000 * 60); // note: the speed was originally based on 60fps, this makes it framerate independent
        if (newX < -this.maxX)
        {
            newX = -this.maxX;
            this.vX = 0;
        }
        if (newX > this.minX)
        {
            newX = this.minX;
            this.vX = 0;
        }

        if (this.arrowPressed == false)
        {
            if (this.vX != 0) this.vX *= 0.94;
        }

        this.xpos = newX;
        this.menuItemsContainer.x = this.xpos;
    }

    onArrowClick(sender)
    {
        let speed = 23;
        if (sender == this.btnLeftArrow)
        {
            this.vX = speed;
        }
        else
        {
            this.vX = -speed;
        }
        this.arrowPressed = true;
    };

    onArrowRelease()
    {
        this.arrowPressed = false;
    }

    setMenu(menuInfo)
    {
        this.clearCurrentMenu();
        let menuType = menuInfo.type;
        let hideArrows = true;
        let isColor = false;

        let color = menuInfo.bgColor;
        if (color == void (0)) color = "#9d9f9e";
        this.subBg.fillColor = Phaser.Display.Color.HexStringToColor(color).color;
        this.menuType = menuInfo.id;

        this.setArrowDisplay(!hideArrows);
        let menuItems = this.makeItemSpritesByPrefix();
        if (menuType == "click")
        {
            this.initClickMenu(menuItems);
            this.menuItems = menuItems;
        }

        if (menuType == "dragdrop")
        {
            this.initDragDropMenu(menuItems);
            this.menuItems = menuItems;
        }
        if (this.menuItems.length > 0)
        {
            const menuItemsContainerWidth = this.menuItemsContainer.getBounds().width;
            if (menuItemsContainerWidth > this.workingWidth - this.SIDE_MARGINS * 2)
            {
                this.setArrowDisplay(true);
                this.scrollSize = (this.workingWidth - this.SIDE_MARGINS * 2) * 0.9;
                this.displayMaxX = (menuItemsContainerWidth - (this.workingWidth - this.SIDE_MARGINS * 2));
                this.minX = 0;
                this.maxX = this.displayMaxX;
                this.vX = 0;
                this.btnRightArrow.setFrame(UIAssetKeys._game_assets_BUTTON_arrow_right_glow);

                // note: this tween isn't a scale tween, it's really just used to flash the button, the scale:1 is used because it needs something to tween otherwise it won't run
                ABCyaPhaser.Tweens.addTween(this.btnRightArrow, 1000, { scale: 1 }, Phaser.Math.Easing.Linear, () =>
                {
                    this.btnRightArrow.setFrame(UIAssetKeys._game_assets_BUTTON_arrow_right);
                    ABCyaPhaser.Tweens.addTween(this.btnRightArrow, 300, { scale: 1 }, Phaser.Math.Easing.Linear, () =>
                    {
                        this.btnRightArrow.setFrame(UIAssetKeys._game_assets_BUTTON_arrow_right_glow);
                        ABCyaPhaser.Tweens.addTween(this.btnRightArrow, 1000, { scale: 1 }, Phaser.Math.Easing.Linear, () =>
                        {
                            this.btnRightArrow.setFrame(UIAssetKeys._game_assets_BUTTON_arrow_right);

                        });
                    });
                });
            }
            else
            {
                this.spreadMenu(menuItems);
            }
        }

        if (isColor)
        {
            this.menuItemsContainer.setVisible(false);
            this.colorItemsContainer.setVisible(true);
        }
        else
        {
            this.menuItemsContainer.setVisible(true);
            this.colorItemsContainer.setVisible(false);
        }
    }

    clearCurrentMenu()
    {
        this.scene.tweens.killTweensOf(this.btnRightArrow);
        this.btnRightArrow.setFrame(UIAssetKeys._game_assets_BUTTON_arrow_right);
        this.xpos = 0;
        this.vX = 0;
        this.menuItemsContainer.x = this.xpos;
        this.menuItemsContainer.removeAll(true);
        this.menuItems.forEach(mi => mi.destroy());
        this.menuItems = [];
        this.colorItems.forEach(ci => ci.destroy());
        this.colorItems = [];
        this.colorSwatches.forEach(cs => cs.destroy());
        this.colorSwatches = [];
        this.colorFillButtonGlow.visible = false;
    }

    setArrowDisplay(show)
    {
        if (show == void (0)) show = true;
        this.btnLeftArrow.setVisible(show);
        this.btnRightArrow.setVisible(show);
    }

    makeItemSpritesByPrefix()
    {
        let x = this.SIDE_MARGINS;
        let padding = 13;

        let found = true;
        let sindex = 1;
        let arrayStore = [];
        while (found)
        {
            let sn = "game-assets/" + this.menuType + "+" + sindex;

            if (this.scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS).has(sn))
            {
                let item = ABCyaPhaser.Images.addImage(0, 0, sn, this).setOrigin(0);
                item.setPosition(x, (this.workingHeight / 2) - (item.height / 2));
                x += item.width + padding;
                arrayStore.push(item);

                // get Spanish patches
                if(ABCyaLib.Environment.instance.gameConfig.hasLocalePatches){
                  sn = this.menuType + "+" + sindex;

                  if (this.scene.textures.get(ABCyaPhaser.Images.LOCALIZATION_ATLAS).has(sn))
                  {
                      let item = ABCyaPhaser.Images.addImage(0, 0, sn, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0);
                      item.setPosition(x, (this.workingHeight / 2) - (item.height / 2));
                      x += item.width + padding;
                      arrayStore.push(item);
                  }
                  else if(this.scene.textures.get(ABCyaPhaser.Images.LOCALIZATION_ATLAS).getFrameNames().some(frameName => frameName.startsWith(sn)))
                  {
                    // we found a Spanish patch that has multiple items (currently only Ú and Ü), add all of them
                    let itemIndex = 0;
                      while (this.scene.textures.get(ABCyaPhaser.Images.LOCALIZATION_ATLAS).has(sn +"_" + itemIndex))
                      {
                        let item = ABCyaPhaser.Images.addImage(0, 0, sn + "_" + itemIndex, this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0);
                        item.setPosition(x, (this.workingHeight / 2) - (item.height / 2));
                        x += item.width + padding;
                        arrayStore.push(item);
                        itemIndex++;
                      }
                  }
                }
            }
            else
            {
                found = false;
            }
  
            sindex++;
        }

        return arrayStore;
    }

    initClickMenu(menuItems)
    {
        let len = menuItems.length;
        for (let i = 0; i < len; i++)
        {
            menuItems[i].on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onItemClick(menuItems[i]), this);
            this.menuItemsContainer.add(menuItems[i].setInteractive());
        }
    }

    onItemClick(sender)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._button_click, this.scene);
        let item = sender;
        let itemIndex = this.menuItems.indexOf(item);
        this.delegate.handleItemClick(this.menuType, itemIndex);
    }

    initDragDropMenu(menuItems)
    {
        let len = menuItems.length;
        for (let i = 0; i < len; i++)
        {
            let item = menuItems[i];
            menuItems[i].once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => this.startDrag(pointer, item), this);
            this.menuItemsContainer.add(menuItems[i].setInteractive({ draggable: true }));
        }
    }

    startDrag(pointer, sender)
    {
        sender.on(Phaser.Input.Events.GAMEOBJECT_DRAG, pointer => this.doDrag(pointer, sender));
        sender.on(Phaser.Input.Events.GAMEOBJECT_POINTER_UP, pointer => this.stopDrag(pointer, sender));
        this.scene.input.once(Phaser.Input.Events.POINTER_UP, pointer => this.stopDrag(pointer, sender));
        let item = sender;
        this.removeLocalItem(item);
        this.makeDragReplacement(item);
        let pos = ABCyaPhaser.GameObjects.getScreenPosition(item);
        item.x = pos.x;
        item.y = pos.y;
        this.dragContainer.add(item);

        item.dragOffsetX = item.x - pointer.x;
        item.dragOffsetY = item.y - pointer.y;

        if (this.menuType == 'KEYCHAIN')
        {
            let tmpChain = this.tmpChain = new KeychainChain(this.scene, item.x + item.width / 2, item.y, item, this.delegate.dropCollisionSprite);
            this.tmpChain.updatePos(item.x + item.width / 2, item.y + item.height / 2);
            this.dragContainer.add(tmpChain);
            this.delegate.addKeychain(tmpChain);
            this.delegate.checkNewItemHit(tmpChain.handle);
            item.alpha = 0.000000001; // allows the object to recieve input, for some reason item.input.alwaysEnabled = true doesn't work
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._keychain, this.scene);
        }
        else
        {
            this.delegate.checkNewItemHit(item);
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._patches, this.scene);
        }
    }

    doDrag(pointer, sender)
    {
        let item = sender;
        let newX = pointer.x + item.dragOffsetX;
        let newY = pointer.y + item.dragOffsetY;
        item.x = newX;
        item.y = newY;
        if (this.menuType == 'KEYCHAIN')
        {
            this.tmpChain.updatePos(item.x + item.width / 2, item.y + item.height / 2);
        }
    }

    stopDrag(pointer, sender)
    {
        this.scene.input.off(Phaser.Input.Events.POINTER_UP);
        let item = sender;
        let newX = pointer.x + item.dragOffsetX;
        let newY = pointer.y + item.dragOffsetY;

        item.x = newX;
        item.y = newY;
        if (this.menuType == 'KEYCHAIN')
        {
            this.tmpChain.enableDrag();
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._keychain, this.scene);
            this.tmpChain.updatePos(item.x + item.width / 2, item.y + item.height / 2);
            let didStick = this.delegate.handleKeychainDrop(this.tmpChain);
            this.dragContainer.remove(item, true);
            if (didStick == false)
            {
                this.dragContainer.remove(this.tmpChain, true);
                item = null;
            }
        }
        else
        {
            ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._patches, this.scene);
            item.removeAllListeners();
            var didStick = this.delegate.handleItemDrop(item);
            if (didStick == false)
            {
                item.removeAllListeners();
                this.dragContainer.remove(item, true);
                item = null;
            }
        }
    }

    removeLocalItem(item)
    {
        Phaser.Utils.Array.Remove(this.menuItems, item);
    }

    /**
     * 
     * @param {Phaser.GameObjects.Image} sprite 
     */
    makeDragReplacement(sprite)
    {
        let item = ABCyaPhaser.Images.addImage(sprite.x, sprite.y, sprite.frame.name, this.menuItemsContainer, sprite.frame.texture.key).setOrigin(0).setInteractive({ draggable: true });
        item.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, pointer => this.startDrag(pointer, item), this);
        this.menuItems.push(item);
    }

    spreadMenu(menuItems)
    {
        let len = menuItems.length;
        let totalWidth = this.menuItemsContainer.getBounds().width;
        let difw = this.scene.scale.width - totalWidth;
        let padding = difw / (len);
        let x = padding;
        for (let i = 0; i < len; i++)
        {
            let item = menuItems[i];
            item.x = x;
            x += item.width + padding;
        }
    }

    setCustomColorMenu(menuInfo)
    {
        this.clearCurrentMenu();
        this.setArrowDisplay(false);
        let color = menuInfo.bgColor;
        if (color == void (0)) color = "#9d9f9e";
        this.subBg.fillColor = Phaser.Display.Color.HexStringToColor(color).color;
        this.menuType = menuInfo.id;
        let x = this.SIDE_MARGINS / 2;
        let padding = 13;

        let found = true;
        let sindex = 1;
        while (found)
        {
            let sn = "game-assets/" + this.menuType + "_fill+" + sindex;
            if (this.scene.textures.get(ABCyaPhaser.Images.DEFAULT_ATLAS).has(sn))
            {
                let item = ABCyaPhaser.Images.addImage(x, 0, sn, this.colorItemsContainer).setOrigin(0).setInteractive();
                item.y = this.workingHeight / 2 - item.height / 2;
                x += item.width + padding;
                item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.onColorPatternFillClick(item));
                this.colorItems.push(item);
            }
            else
            {
                found = false;
            }
            sindex++;
        }

        x += 40;
        // Color buttons
        let bX = x;
        let bY = padding;
        let cnt = menuInfo.data.colors.length;

        for (let i = 0; i < cnt; i++)
        {
            let colorId = menuInfo.data.colors[i];
            let item = new ColorSelectionButton(this.scene, menuInfo.data.colorValues[colorId]);
            item.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => this.colorClick(item));
            item.x = bX;
            item.y = bY + item.height / 2;
            bX += item.width + padding;
            if (i == cnt / 2 - 1)
            {
                bY += item.height + padding;
                bX = x;
            }
            this.colorSwatches.push(item);
            this.colorItemsContainer.add(item);
        }

        this.colorItemsContainer.setVisible(true);
    }

    colorClick(target)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._color, this.scene);
        let item = target;
        let itemIndex = this.colorSwatches.indexOf(item);
        let colorName = gameData.menu[1].data.colors[itemIndex];
        this.delegate.colorBackpack(gameData.menu[1].data.colorValues[colorName]);
    }

    onColorPatternFillClick(target)
    {
        ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._color, this.scene);
        let item = target;
        let itemIndex = this.colorItems.indexOf(item);
        let fillType = gameData.menu[1].data.fillTypes[itemIndex];
        this.delegate.setColorFillType(fillType);
        this.colorFillButtonGlow.visible = true;
        this.colorFillButtonGlow.x = item.x + this.colorFillButtonGlow.halfWidth - 2;
        this.colorFillButtonGlow.y = item.y + this.colorFillButtonGlow.halfHeight - 2;
    }
}